const API_BASE_URL = "https://alternative-lamprey-fatma-celik-a9c7fc96.koyeb.app/api";

// Token'ı localStorage'a kaydetme
export const setToken = (token) => {
  try {
    localStorage.setItem("jwt_token", token);
  } catch (error) {
    console.error("Token kaydedilemedi:", error);
  }
};

// Token'ı localStorage'dan alma
export const getToken = () => {
  try {
    return localStorage.getItem("jwt_token");
  } catch (error) {
    console.error("Token okunamadı:", error);
    return null;
  }
};

// Token'ı silme
export const removeToken = () => {
  try {
    localStorage.removeItem("jwt_token");
  } catch (error) {
    console.error("Token silinemedi:", error);
  }
};

// Kullanıcı bilgilerini localStorage'a kaydetme
export const setUser = (user) => {
  try {
    localStorage.setItem("user", JSON.stringify(user));
  } catch (error) {
    console.error("Kullanıcı bilgileri kaydedilemedi:", error);
  }
};

// Kullanıcı bilgilerini localStorage'dan alma
export const getUser = () => {
  try {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  } catch (error) {
    console.error("Kullanıcı bilgileri okunamadı:", error);
    return null;
  }
};

// Kullanıcı bilgilerini ve token'ı temizleme
export const clearAuth = () => {
  try {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("user");
  } catch (error) {
    console.error("Auth temizlenemedi:", error);
  }
};

// Giriş yapma
export const login = async (email, password) => {
  try {
    console.log("Giriş yapılıyor:", email);
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    console.log("Response status:", response.status);
    if (!response.ok) {
      const errorData = await response.json();
      console.error("Login error:", errorData);
      throw new Error(errorData.error || "Giriş yapılırken hata oluştu");
    }
    const data = await response.json();
    console.log("Login response:", data);
    if (data.success) {
      // Token'ı ve kullanıcı bilgilerini localStorage'a kaydet
      setToken(data.token);
      setUser(data.user);
      return { success: true, user: data.user };
    } else {
      throw new Error(data.error || "Giriş başarısız");
    }
  } catch (error) {
    console.error("Login exception:", error);
    return { success: false, error: error.message };
  }
};

// Çıkış yapma
export const logout = () => {
  clearAuth();
};

// Şifre değiştirme
export const changePassword = async (currentPassword, newPassword) => {
  const token = getToken();
  if (!token) {
    throw new Error("Oturum açılmamış");
  }
  try {
    console.log("🔄 Şifre değiştirme isteği gönderiliyor...");
    const response = await fetch(`${API_BASE_URL}/change-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        current_password: currentPassword, // snake_case olarak değiştirildi
        new_password: newPassword, // snake_case olarak değiştirildi
      }),
    });

    console.log("📡 Response status:", response.status);

    const data = await response.json();
    console.log("📦 Response data:", data);

    if (!response.ok) {
      throw new Error(data.error || "Şifre değiştirilemedi");
    }
    return data;
  } catch (error) {
    console.error("❌ Şifre değiştirme hatası:", error);
    throw new Error(error.message || "Şifre değiştirilirken hata oluştu");
  }
};

// Yetkili istekler için fetch wrapper
export const authFetch = async (url, options = {}) => {
  const token = getToken();
  console.log(
    "🔍 Gönderilen token:",
    token ? `${token.substring(0, 20)}...` : "Token yok"
  );

  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
    console.log("🔍 Authorization header eklendi");
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  console.log(
    `🔍 İstek: ${options.method || "GET"} ${url}, Status: ${response.status}`
  );

  // Eğer token süresi dolmuşsa (401), çıkış yap
  if (response.status === 401) {
    console.error("🚫 401 Unauthorized - Token süresi dolmuş");
    logout();
    window.location.href = "/login";
    throw new Error("Oturum süresi dolmuş, lütfen tekrar giriş yapın");
  }

  // 403 hatası için debug
  if (response.status === 403) {
    console.error("🚫 403 Forbidden - Yetki hatası");
    const errorText = await response.text();
    console.error("🚫 Hata detayı:", errorText);
  }

  return response;
};
// Yönlendirme için yardımcı fonksiyon
export const redirectBasedOnRole = (user) => {
  if (!user || !user.role) return "/login";

  const role = user.role.toLowerCase();

  if (role === "maintenance_admin") {
    return "/maintenance";
  } else if (role === "admin") {
    return "/admin";
  } else if (role === "employee" || role === "user") {
    return "/employee";
  } else {
    return "/login";
  }
};
